const url = new URL(window.location.href);
url.pathname = url.pathname.replace(/^\/*/, '/');
url.hash = url.hash.replace(/^#?\/*/, '#/');
window.history.replaceState(null, '', url.href);
